import { useMutation } from '@tanstack/react-query';

import { $api, errorHandler } from 'modules/global';

export const useCreateApplication = () =>
  useMutation({
    mutationFn: async (application: { phone?: string; ticket_id?: number; user_name: string, university_id?: string }) => {
      const { data } = await $api.post('/application-create', application);

      return data;
    },
    onError: errorHandler()
  });
